export const WEGNOLOGY_RED = '#023867'
